import { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import './i18n';
import './sentry';

import { HelmetProvider } from 'react-helmet-async';

import App from './app';
import { AuthProvider } from './context/AuthProvider';
import { DoctorProvider } from './context/DoctorProvider';

// ----------------------------------------------------------------------

// bokeh throws a lot of warnings in console for no reason, so block them in production
if (import.meta.env.PROD) {
  const consoleWarn = console.warn;
  console.warn = (message: unknown, ...args: unknown[]) => {
    if (message !== '[bokeh]') consoleWarn(message, ...args);
  };
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);

root.render(
  <HelmetProvider>
    <BrowserRouter>
      <Suspense>
        <AuthProvider>
          <DoctorProvider>
            <App />
          </DoctorProvider>
        </AuthProvider>
      </Suspense>
    </BrowserRouter>
  </HelmetProvider>
);
